import React, { memo } from "react";
import { useReactFlow, Controls } from "@xyflow/react";
import Styles from "./ZoomControls.module.scss";
import Icon from "../../theme/icon/Icon";
import Button from "../../theme/button/Button";

function CustomZoomControls() {
    const { zoomIn, zoomOut } = useReactFlow();

    return (
        <Controls
            showZoom={false}
            showFitView={false}
            showInteractive={false}
            orientation="horizontal"
            position="bottom-right"
            className={Styles["custom-zoom-controls"]}
        >
            <Button
                onClick={() => zoomOut()}
                variant="none"
                size="small"
                prefixIcon={<Icon.ZoomOut variant="default" />}
            />
            <Button
                onClick={() => zoomIn()}
                variant="none"
                size="small"
                prefixIcon={<Icon.ZoomIn variant="default" />}
            />
        </Controls>
    );
}

export default memo(CustomZoomControls);
